export default {"src":"/_next/static/media/user-login.5f8ee646.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};